<template>
  <div class="tags-menu">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.true') }}</option>
      <option :value='false'>{{ $t('root.filters.false') }}</option>
    </select>

    <label>{{ $t('root.filters.tags') }}</label>
    <multi-select v-model='selectedTags' :getter='getTags' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../_infinite_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        predicate: true,
        selectedTags: [],
      }
    },
    computed: {
      selectedTagIds() {
        return this.selectedTags.map(c => c.id)
      },
      predicateQuery() {
        return this.predicate ? 'filters[tags_id_in]' : 'filters[tags_id_not_in]'
      }
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[tags_id_in]']
        delete newQuery['filters[tags_id_not_in]']

        newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, [this.predicateQuery]: this.selectedTagIds })

        this.$router.push({ query: newQuery })
      },
      getTags(params) {
        return this.listStore.getTags(params)
      },
    }
  }
</script>

<style lang="sass" scoped>
  .tags-menu
    width: 250px
    padding: 10px
  .float-right
    margin-top: 15px
  select
    margin-bottom: 10px
</style>
